import React, { memo } from 'react';

import { Box, Tooltip, Typography } from '@mui/material';

import { dotStyles, indicatorStyles } from './NavNeededIndicator.styles';

/**
 * The "● Needed" pill surfaced on a loan-editor nav item (outer rail + inner
 * section nav) when a checklist roll-up reports a still-needed field below it
 * (DEV-4496, Style C). Purely presentational — the caller decides when to render
 * it from `selectIncompleteLinkedNav`. Pairs with the row highlight in
 * `NavNeededIndicator.styles` (`navNeededRowStyles` / `getRailAccentStyles`).
 */
const NavNeededIndicator = () => (
  <Tooltip title="A field below still needs attention">
    <Box component="span" sx={indicatorStyles}>
      <Box component="span" sx={dotStyles} />
      <Typography component="span" variant="medium12">
        Needed
      </Typography>
    </Box>
  </Tooltip>
);

export default memo(NavNeededIndicator);
